import type { ReactNode } from "react";

export function LoadingGrid({ rows = 4 }: { rows?: number }) {
  return (
    <div className="skeleton-grid" aria-label="Loading">
      {Array.from({ length: rows }, (_, index) => (
        <div className={`skeleton ${index < 2 ? "hero" : ""}`} key={index} />
      ))}
    </div>
  );
}

export function EmptyState({ title, message, action }: { title: string; message: string; action?: ReactNode }) {
  return (
    <section className="card empty-state">
      <div>
        <h2>{title}</h2>
        <p>{message}</p>
        {action}
      </div>
    </section>
  );
}
